import { graphql } from "@/gql";

export const adminDashboardStatsQuery = graphql(`
  query DashboardStats(
    $start: DateTimeTz!
    $end: DateTimeTz!
    $comparisonMode: ComparisonMode!
  ) {
    adminDashboardStats(
      start: $start
      end: $end
      comparisonMode: $comparisonMode
    ) {
      bookings {
        date
        count_cancelled
        count_confirmed
        count_pending
        count_vip
        count_completed
      }
      bookings_count
      bookings_trend
      bookings_total_trend
      waitlists_count
      waitlists_trend
      pro_drivers_count
      pro_drivers_trend
      relocations_trend
      work_orders_trend
      android_bookings_count
      ios_bookings_count
      web_bookings_count
      unknown_platform_bookings_count
      regions {
        region
        bookings_count
        bookings_pending_count
        bookings_cancelled_count
        relocations_count
        relocations_original_count
        waitlists_count
        pro_drivers_count
        work_orders_count
      }
    }
  }
`);
